/**
 * Page-furniture settings for the template editor.
 *
 * A clause is a fragment: `insertDocxFragment` carries only its body paragraphs
 * into a document, never its page size, margins, headers, footers or
 * watermark. So a clause edits as one continuous column with no page furniture
 * (the header/footer bands would otherwise sit over the text), while an
 * agreement template keeps full pages.
 */
export function templatePageChrome(isClauseTemplate: boolean | undefined) {
  const isClause = !!isClauseTemplate;
  return {
    pageChrome: isClause ? ('continuous' as const) : ('pages' as const),
    showRuler: !isClause,
    allowPageSetup: !isClause,
    allowWatermark: !isClause,
    allowHeaderFooterLock: !isClause,
  };
}
